import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'

class Header extends Component {
    render() {
        return (
            <header>
                <ScrollToTopOnMount/>
                <div className="container">
                    <nav className="menu-header clearfix">
                        <div className="float-left">
                            <div className="logo-header">
                                <Link to="/"><img src="/images/logo.png" className="img-fluid" alt="サシイレ" /></Link>
                            </div>
                        </div>
                        <div className="float-right">
                            <div className="qa-header">
                                <ul className="clearfix">
                                    <li>
                                        <img src="/images/icon_qa.png" />
                                    </li>
                                    <li>
                                        <Link to="/faq">
                                            <div>よくあるご質問</div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        )
    }
}

export default Header